<template>
    <section class="panel">
            <header class="panel-heading">
                <h2 class="panel-title">Paquetería Reciente</h2>
            </header>
            <div class="panel-body" v-if="isLoading">
                <img src="/assets/images/loading.gif" alt="loading..." />
            </div>
            <div class="panel-body" v-if="!isLoading">
                <div v-for="mail in mails" :key="mail.id" >
                    <h3>Guia No. {{ mail.guideNumberTracking }} <span class="badge">{{ formatStatus(mail.status) }}</span></h3>
                    <p class="lead mt-xs"><b>Fecha:</b> {{ formatDate(mail.dateTime) }}, <b>Tipo:</b> {{ formatType(mail.type) }}, <b>Mensajeria:</b> {{ mail.parcel }}</p>
                    <p class="lead mt-xl mb-xs"><b>Remitente:</b>{{mail.fullName}}</p>
                    <p class="lead mt-xl mb-xs"><b>Dirigido a:</b>
                        <div v-for="(user, index) in formatOfficeUser(mail.officeUser)" :key="index">
                            {{user}}<br>
                        </div>
                    </p>
                    <div v-if="mail.filePDF!=null">
                        <a class="mb-xs mt-xs mr-xs btn btn-primary" @click="downloadFilePdfLink(mail.id, mail.filePDF)">
                            <i class="fa fa-download"></i> Descargar PDF
                        </a>
                    </div>
                    <!--<div v-if="mail.packageImage!=null">
                        <a class="mb-xs mt-xs mr-xs btn btn-primary" @click="downloadPakageImageLink(mail.id, mail.packageImage)">
                            <i class="fa fa-download"></i> Imagen del Paquete
                        </a>
                    </div>
                    <div v-if="mail.signatureDelivered!=null">
                        <a class="mb-xs mt-xs mr-xs btn btn-primary" @click="downloadSignatureDeliveredLink(mail.id, mail.signatureDelivered)">
                            <i class="fa fa-download"></i> Firma de Entregado
                        </a>
                    </div>  -->
                    <hr />
                </div>
            </div>          
     </section>        
</template>

<script>
    export default {
        name: 'Mails',
        data: function () {
            return {
                isLoading : true,
                mails : {}
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.refresh();
            });
        },
        computed: {
            accountId () {
                return this.$store.state.accountId
            }
        },
        methods: {
            async downloadFileCore(fileType, mailId, filePath) {                                        
                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;
                var link = `${process.env.VUE_APP_API_PATH}mails/${mailId}/download/${fileType}/?filePath=${filePath}&a=${jwtAccessToken}&i=${jwtIdToken}`;
                window.open(link, '_blank');
            },
            async downloadImageCore(fileType, mailId, filePath) {                                        
                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;
                var link = `${process.env.VUE_APP_API_PATH}mails/${mailId}/downloadPhoto/${fileType}/?filePath=${filePath}&a=${jwtAccessToken}&i=${jwtIdToken}`;
                window.open(link, '_blank');
            },
            async downloadFilePdfLink(mailId, filePath) {
                await this.downloadFileCore("file_pdf", mailId, filePath);
            },
            async downloadPakageImageLink(mailId, filePath) {
                await this.downloadImageCore("package_image", mailId, filePath);                
            },
            async downloadSignatureDeliveredLink(mailId, filePath) {
                await this.downloadFileCore("signature_of_delivered", mailId, filePath);                
            },
            formatDate: function (dateString) {
                var date = new Date(dateString);
                // https://www.npmjs.com/package/dateformat
                var dateFormat = require('dateformat');
                return dateFormat(date, "mmmm dS, yyyy");
            },
            formatType: function (mailType) {
                var type = new String;
                switch (mailType) {
                    case "Envelope": type= "Sobre"; break; 
                    case "Box": type= "Caja"; break; 
                    case "Package": type= "Paquete"; break; 
                    default: type= mailType; break; 
                    }
                return type;
            },
            formatStatus: function (mailStatus) {
                var status = new String;
                switch (mailStatus) {
                    case "Pending": status= "Pendiente"; break; 
                    case "Delivered": status= "Entregado"; break; 
                    default: status= mailStatus; break; 
                    }
                return status;
            },
            formatOfficeUser: function(mailOfficeUser){
                var officeUser = new String;
                officeUser = mailOfficeUser.split(" - ").slice(0,-1);
                return officeUser;
            },
            async refresh () {
                var self = this;
                this.isLoading = true;
                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;

                this.axios.get(process.env.VUE_APP_API_PATH + "mails/list",
                                        {
                            headers: {
                                Authorization: `Bearer ${jwtAccessToken}`,  // send the access token through the 'Authorization' header,
                                IdToken: `${jwtIdToken}`
                            }
                        }
                    ).
                    then(function (response) {
                        //console.debug(response.data);
                        self.mails = response.data;
                        self.isLoading = false;
                    }, function (error) {
                        self.isLoading = false;
                    });
            }
        }
    }
</script>